export default "__VITE_ASSET___oRUhtA6__"